module.exports = __webpack_public_path__ + "static/Lenore_0126-1ca672766b282c0fe8846e58c7f1a3a8.png";